<div class="form-subcontainer form-layout-3">
    <div class="form-content">
        <ng-container *ngIf="!state.isOtpChannel" >
            <div>
                <form  formName="preloginOtp" autocomplete="off" [formGroup]="formGroup" (ngSubmit)="submit()" class="fpx-form-group">
    
                    <div class="fpx-form-group">
                        <section class="pre-login-form">
                            <h3 class="frm-title">{{'OTPPAGE.title'| translate}}</h3>
                            <div class="frm-desc">
                                <span class="otp-hint">{{'OTPPAGE.hint'| translate}} </span><br />
                                <span class="otp-ph-no" *ngIf="state.emailId"> {{'OTPPAGE.email'| translate}} {{state.emailId}}</span>
                                <span class="otp-ph-no"  *ngIf="state.mobileNum"> {{'OTPPAGE.phone'| translate}} {{state.mobileNum}}</span>
                                <span class="otp-ph-no"  *ngIf="state.whatsapp"> Whatsapp {{state.whatsapp}}</span>
                            </div>
                            <div class="details-entry-panel">
                                <div class="fpx-field">
                                    <otp-input #otpInput [activeSpan]="state.activeSpan" formControlName="otpInput"></otp-input>
                                </div>
                                <div class="error-login">
                                    <mat-error class="prelogin-error" *ngIf="state.isError">
                                        {{state.otpError}}
                                    </mat-error>
                                </div>
    
    
                                <div class="otp-timer-grp">
                                    <span id="otpTimer" class="otp-timer">{{state.displayTimer}}</span>
                                    <span class="otp-timer-desc"> {{'OTPPAGE.timerDesc'| translate}}</span>
                                </div>
                                <div class="otp-resend">{{'OTPPAGE.resendCodeLable'| translate}} <span
                                        [ngClass]="{'disable-resend': state.expireSec > 0}" class="otp-resend-link"
                                        (click)="onClickResendBtn()">{{'OTPPAGE.resendCodelink'| translate}}</span></div>
                            </div>
                        </section>
                        <section class="frm-actions-group">
                            <button type="button" class="btn-back secondary" clickable (click)="onClickBackBtn()">
                                <img src="./assets/images/back-arrow-grey.svg" />
                          <div class="btn-desc">Back</div>
                            </button>
                            <button type="submit" [disabled]="!state.buttonEnable" class="verify-btn button-common button40">
                              <span>Verify</span>
                            </button>
                        </section>
                    </div>
                </form>
    
               
            </div>
        </ng-container>
      

        <ng-container *ngIf="state.isOtpChannel">
            <form formName="preloginOtp" autocomplete="off" [formGroup]="formGroup" class="fpx-form-group">
                <div class="otp-channel-main-container">
                    <div class="otp-channel-form">
                        <div class="otp-channel-title">OTP Management</div>
                        <div class="otp-channel-subtitle">Please set your preferred One time password (OTP) delivery method at ease.</div>
                        <div class="fpx-form-control-group">
                            <div class="fpx-field">
                                <app-option labelPosition="after" direction="column"
                                formControlName="otpChannelOption"
                               ></app-option>
                            </div>
                            <section class="frm-actions-group">
                                <button type="button" class="btn-back secondary" clickable (click)="onClickBackBtn()">
                                    <img src="./assets/images/back-arrow-grey.svg" />
                                    <div class="btn-desc">Back</div>
                                </button>
                                <button (click)="submitChannel()" type="button" class="button-common button40">
                                    <span>Next</span>
                                </button>
                            </section>
                        </div>
                    </div>
        
                </div>
            </form>
        </ng-container>
    </div>
</div>
